<template>
  <div class="form">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <h1 align="center" style="text-decoration: underline overline">
      IMBANGAN PENDAPATAN DAN PERBELANJAAN 
    </h1>

    <v-text-field
      outlined
      dense
      rounded
      v-model="HID"
      label="HID"
      :rules="rules"
      width="20px"
      disabled
    ></v-text-field>

    <!-- DATATABLE  -->
    <v-card>
      <v-card-title>
        Senarai
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataJR2Imbangan"
        :search="search"
        class="ml-3 mr-3"
        @click:row="handleClick"
        :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
      ></v-data-table>
    </v-card>

    <v-card>
      <v-card-title>  </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          
          <v-row>
            <v-col>
              <strong>PENDAPATAN DAN PENERIMAAN LAIN ISI RUMAH</strong>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="4">
              Pendapatan Kasar sebulan <strong>[INCS 07/12]</strong><br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="INCS07P12"
                label="RM"
                type="number"
                min="0"
                :disabled="true"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="4">
              Penerimaan lain sebulan <strong>[INCS 09]</strong><br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOTINCS09"
                type="number"
                label="RM"
                :disabled="true"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="4"> Jumlah <strong>[B]</strong><br /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUMLAH_B"
                label="RM"
                type="number"
                min="0"
                @keypress="isNumber($event)"
                disabled
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col> <strong> IMBANGAN</strong>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="20" sm="3" md="4">
              Jumlah Perbelanjaan dan Pembayaran Lain Isi Rumah <strong>[A]</strong> <br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOT_A"
                label="RM"
                type="number"
                min="0"
                :disabled="true"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="20" sm="3" md="4">
              Jumlah Pendapatan dan Penerimaan Lain Isi Rumah <strong>[B]</strong><br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOT_B"
                label="RM"
                type="number"
                min="0"
                :disabled="true"
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="20" sm="3" md="4">
              Imbangan (%) <strong>[C]</strong>

              <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-alert-circle
                </v-icon>
              </template>
              <span> * Sekiranya % Imbangan adalah kurang daripada 90% atau lebih daripada 110%,<br>
                       responden perlu menyemak semula pendapatan dan perbelanjaan. </span>
              </v-tooltip>

               <br/>
            </v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                maxlength="3"
                v-model="TOT_C"
                label="%"
                min="0"
                @keypress="isNumber($event)"
                disabled
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col cols="20" sm="3" md="4"> Catatan <br /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="5">
              <v-textarea
                outlined
                dense
                v-model="CATATAN"
                label=""
                auto-grow
                rows="3"
                row-height="25"
                shaped
              ></v-textarea
            ></v-col>
          </v-row>
          <v-row> </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
    <v-btn text color="primary" @click="simpan()"> Pengesahan </v-btn>
        <!-- <v-btn text color="primary" @click="goBack()"> Kembali </v-btn> -->
      </v-card-actions>
    </v-card>

    <v-alert prominent type="error" :value="popUpALert">
      <v-row align="center" class="mb-2">
        <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
          <v-btn @click="padam('2')">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from "@/services/lookupField";
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
  //props:['data'],
  
  async beforeMount() {
     //let data = this.$route.params.data;
     // console.log("data is", data);
    var dataHID = localStorageData.getHIDdata();

    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB = dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.Bulan = dataHID.BULAN;
    this.Tahun = dataHID.TAHUN;

    this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
    this.NOAIR = this.currNOAIRData.NOAIR;

    this.getData();
    this.getINCS09()
    this.getTOT_A()
    this.getINCS07P12()
     //dapatkan data based on HID
  },
   mounted(){
      let data = this.$route.params.dataz;
      console.log( data);
      let num = Number(data.INCS07) /12;
      this.INCS07P12 = num.toFixed(2) ;
      this.INCS07 = data.INCS07;
      this.TOTINCS09 = data.INCS09;

      
      this.INCS21NA = data.INCS21NA;
      this.INCS21 = data.INCS21;
      this.INCS01 = data.INCS01;
      this.INCS02 = data.INCS02;
      this.INCS03 = data.INCS03;
      this.INCS05 = data.INCS05;
      this.INCS06 = data.INCS06;
      this.INCS08 = data.INCS08;
      this.INCS10 = data.INCS10;
      this.TP73 = data.TP73;

    },

  data: () => ({
    updateButton: true,
    saveButton: false,
    dialog: false,
    successDialog: false,
    errorDialog: false,
    successMessage: "",
    errMessage: "",
    message: "Saving Data",
    popUpALert: false,
    search: "",
    currNOAIRData:'',
    /////////////////////data declaration//////////////////////////
    HID: "",
    INCS01: 0.00,
    INCS05: 0.00,
    INCS10: 0.00,
    TOTINCS09: 0.00,
    INCS07P12: 0.00,
    INCS07: 0.00,
    TOT_A: 0.00,
    TOT_B: 0.00,
    TP73: 0.00,
    CATATAN: "",
    //NOAIR:'',
    dataJR2Imbangan: [],
    rules: [
    value => !!value || 'Required.',
        ],
    headers: [
      {
        //text: "NOAIR",
        align: "start",
        sortable: false,
        //value: "NOAIR",
      },
      { text: "HID", value: "HID" },
      { text: "Pendapatan Kasar Sebulan", value: "INCS07P12" },
      { text: "Penerimaan Lain Sebulan", value: "TOTINCS09" },
      { text: "Jumlah [B]", value: "JUMLAH_B" },
      { text: "Imbangan [A]", value: "TOT_A" },
      { text: "Imbangan [B]", value: "TOT_B" },
      { text: "Imbangan [%]", value: "TOT_C" },
      { text: "Catatan", value: "CATATAN" },
    ],

    ///////////link untuk ke page/////////////////////
    breadcrumbs: [
      {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
      },
      // {
      //   text: "Perbelanjaan (Sebulan)",
      //   disabled: false,
      //   href: "PERBELANJAAN",
      // },
      {
        text: "JR2 Imbangan",
        disabled: true,
        href: "JR2Imbangan",
      },
    ],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),

  methods: {
   
    getUnits: function (a) {
      alert(`${a}`);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    // kiraINCS07P12() {
    //   var total = 0;
    //   total = Number(this.INCS07P12) / 12;
    //   this.INCS07P12 = total;
    // },
    kiraJUMLAH_B() {
      var total = 0;
      total = Number(this.INCS07P12) + Number(this.TOTINCS09);
      //this.JUMLAH_B = total.toFixed(2);
    },
    kiraTOT_C() {
      var total = 0;
      total = (Number(this.TOT_A) / Number(this.TOT_B)) * 100;
      //this.TOT_C = total;

      let num = total;
      this.TOT_C = num.toFixed(2) ;
    },

    async simpan(){//faisTambah kak mai check balik betoi ka nak save semua ni
      // console.log(this.INCS21NA)
      console.log(this.INCS21)
      console.log(this.INCS02)
      console.log(this.INCS03)
      console.log(this.INCS06)
      console.log(this.INCS07)
      console.log(this.INCS08)

      try{

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/pengesahan/updateHID`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                totalINCS21NA : this.INCS21NA,
                totalINCS21 : this.INCS21,
                totalINCS02 : this.INCS02,
                totalINCS03 : this.INCS03,
                totalINCS01 : this.INCS01,
                totalINCS05 : this.INCS05,
                totalINCS06 : this.INCS06,
                totalINCS07 : this.INCS07,
                totalINCS08 : this.INCS08,
                totalINCS10 : this.INCS10,
                totalTP73: this.TP73,
                jumBelanjaA: this.TOT_A,
                Sample: this.S,
                TOTINCS09: this.TOTINCS09,
                INCS07P12: this.INCS07P12,
                JUMLAH_B: this.JUMLAH_B,
                TOT_A: this.TOT_A,
                TOT_B: this.TOT_B,
                TOT_C: this.TOT_C,
                CATATAN: this.CATATAN,
                statusHID: 4
              })
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                this.reset();
                this.getData();
                //this.goTo();
                
            } catch (error) {
              console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 4000);
              this.errMessage = "Sila semak pengisian semula!";

              //this.errMessage = 'Simpan : '+error;
            }
      },

    async padam(val) {
      if (val == 0) {
        this.popUpALert = true;
      } else if (val == 1) {
        try {
          ///////////tunjukkan alert padam////////////
          this.popUpALert = false;
          ////send delete to API///////
          if (this.$refs.form.validate()) {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/IMBANGAN/IMBANGAN/delete`,
              {
                HID: this.HID,
                NOAIR: this.NOAIR,
              }
            );
            this.res = res.data;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Deleted!";
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData();
          } else {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field";
          }
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Padam : " + error;
        }
      } else if (val == 2) {
        this.popUpALert = false;
      }
    },

    async getINCS09(){
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getINCS09?HID=`+this.HID, {
      
            })
            var dataz = res.data.data;
            console.log(dataz);
            var total = 0;
            for(var i = 0;i<dataz.length;i++){
              total = total + Number(dataz[i].INCS09);
            }
            this.TOTINCS09 = total;
            //console.log(this.TOTINCS09)
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 4000);
            this.errMessage = "Sila semak pengisian di Penerimaan Bulan Sebelumnya (JRB)";

            //this.errMessage = 'getData : '+ error;
          }
      },

      async getTOT_A(){
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getTOT_A?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
      
            })
            var dataz = res.data.data
            this.TOT_A = Number(dataz[0].jumBelanjaA);
            //console.log(this.TOT_A)
          } catch (error) {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 4000);
            this.errMessage = "Sila semak pengisian di Perbelanjaan (Sebulan)";

            //this.errMessage = 'getData : '+ error;
          }
      },

      //  async getINCS07P12(){
      //   try {
      //       const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getINCS07P12?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
     
      //       })
      //       var dataz = res.data.data
      //       this.INCS07P12 = Number(dataz[0].INCS07);
      //       this.INCS07P12 = Number(this.INCS07P12) / 12;
      //       //this.INCS07P12 = jumBelanjaA.toFixed(2);
      //       console.log(this.INCS07P12)
      //     } catch (error) {
      //       //console.log(error)
      //       this.errorDialog = true;
      //       setTimeout(() => (this.errorDialog = false), 2000);
      //       this.errMessage = 'getData : '+ error;
      //     }
      // },

      
    async getData() {
    
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getDataJR2Imbangan?HID=`+this.HID+`&NOAIR=01`,{}
        );
        var dataz = res.data.data;
        this.dataJR2Imbangan = dataz;
        console.log(this.dataJR2Imbangan)
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },


    handleClick(row) {
      this.saveButton = true;
      this.updateButton = false;

      this.HID = row.HID;
      this.NOAIR = row.NOAIR;
      this.INCS07P12 = row.INCS07P12;
      this.TOTINCS09 = row.TOTINCS09;
      this.JUMLAH_B = row.JUMLAH_B;
      this.TOT_A = row.TOT_A;
      this.TOT_B = row.TOT_B;
      this.TOT_C = row.TOT_C;
      this.CATATAN = row.CATATAN;

      // or just do something with your current clicked row item data
      //console.log(row);
    },

    goTo() {
      this.$router.push({name: "ringkasanMaklumatIR"});
    },
    goBack() {
      this.$router.push({ name: "PERBELANJAAN" });
    },
    
    goToBorang(val) {
      var selectedSektor = val.id;
      if (selectedSektor == 1) {
        this.$router.push({ name: "hk2" });
      }
      if (selectedSektor == 2) {
        this.$router.push({ name: "hk3" });
      }
      if (selectedSektor == 3) {
        this.$router.push({ name: "hk4" });
      }
      if (selectedSektor == 4) {
        this.$router.push({ name: "hk5" });
      }
      if (selectedSektor == 5) {
        this.$router.push({ name: "hk6" });
      }
    },
    isNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  watch:{
    JUMLAH_B(val){
        this.TOT_B = Number(this.JUMLAH_B)
      },
    // INCS07P12(val){
    //   this.INCS07P12 = Number(this.INCS07P12) / 12;
    //   console.log(this.INCS07P12)
    // },
  },
  computed: {
    INCS09: function () {
      var total = 0;
      total =
        Number(this.JUM9a) +
        Number(this.JUM9b) +
        Number(this.JUM9c) +
        Number(this.JUM9d) +
        Number(this.JUM9e);
      return total;
    },
    // INCS07P12: function () {
    //   var total = 0;
    //   total = Number(this.INCS07P12) / 12;
    //   return total;
    // },
    JUMLAH_B: function () {
      var total = 0;
      total = Number(this.INCS07P12) + Number(this.TOTINCS09);
      return total;
    },
    TOT_C: function () {
      var total = 0;
      total = (Number(this.TOT_A) / Number(this.TOT_B)) * 100;
      return total;
    },
    
    
  },
  
  
};
</script>

<style>
#app {
  background: url("~@/assets/HIES.jpg") no-repeat center center fixed !important;
  background-size: cover;
}
</style>


